const validateRequiredField = (value) => {
  if (value && value.length >= 1) {
    return -1;
  } else {
    return 0;
  }
};

const validateDateOfBirthField = (value) => {
  if (value && value.length === 10) {
    return -1;
  } else {
    return 0;
  }
};

const validateEmailField = (value) => {
  if (value && /(.+)@(.+){2,}\.(.+){2,}/.test(value)) {
    return -1;
  } else {
    return 0;
  }
};

const validateAgeRequirement = (value) => {

  var today = new Date();
  var birthDate = new Date(value);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  if (age < 13) {
    return 501;
  } else {
    return -1;
  }

}

const FormValidator = {
  validateRequiredField: validateRequiredField,
  validateDateOfBirthField: validateDateOfBirthField,
  validateEmailField: validateEmailField,
  validateAgeRequirement: validateAgeRequirement
};

export default FormValidator;
